<template>
  <div
    style="text-align: right;"
  >
    <el-tooltip
      class="item"
      effect="dark"
      content="Módosítás"
      placement="top"
      v-can="'todo.update'"
    >
      <el-button
        size="mini"
        icon="el-icon-edit"
        @click="updatePattern"
      />
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="dark"
      :content="'Törlés'"
      placement="top"
      style="margin-left: 5px;"
      v-can="'todo.delete'"
    >
      <el-popover
        placement="bottom"
        width="171"
        v-model="deleteConfirmVisible"
      >
        <p>Biztosan törölni szeretnéd?</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="deleteConfirmVisible = false"
          >
            Mégse
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deletePattern"
          >
            Törlés
          </el-button>
        </div>
        <el-button
          slot="reference"
          :loading="deleteButtonLoader"
          size="mini"
          icon="el-icon-delete"
        />
      </el-popover>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  props: ['pattern'],
  data() {
    return {
      deleteButtonLoader: false,
      deleteConfirmVisible: false
    };
  },

  methods: {
    async deletePattern() {
      this.deleteButtonLoader = true;
      this.deleteConfirmVisible = false;
      try {
        await this.$store.dispatch('todoRecurringPattern/delete', this.pattern.id);
        this.$store.dispatch('todoRecurringPattern/fetchAll');
      } catch (e) {
      }
      this.deleteButtonLoader = false;
    },
    async updatePattern() {
      this.$router.push('/todo-recurring-patterns/update/' + this.pattern.id);
    }
  }
};
</script>
